var m = require('mithril');
var prop = require('mithril/stream');
var verticalListItem = require('../components/verticalListItem');
var equipmentModel = require('./models/equipment');

var component = {};

component.oninit = function oninit (vnode) {
  var ctrl = this;

  ctrl.equipmentRootNode = prop({});
  ctrl.selectedNode = prop(false);
  ctrl.selectedEquipmentClass = vnode.attrs.equipmentClass;
  ctrl.onClassChange = vnode.attrs.onClassChange;
  ctrl.rootNodeSelected = prop(false);
  ctrl.path = prop([]);
  ctrl.searchTerm = prop('');
  ctrl.flatClassEntries = prop([]);

  ctrl.selectRoot = function () {
    vnode.attrs.equipmentClass(null);
    ctrl.selectedNode(ctrl.equipmentRootNode().sort((a, b) => a.name.localeCompare(b.name)));
    ctrl.rootNodeSelected(true);
    ctrl.path(['root']);
  };

  ctrl.buildFlatClassEntries = function (nodes, parentPath, target) {
    if (!Array.isArray(nodes)) return;
    nodes.forEach(function (node) {
      if (!node || !node.name) return;
      var nextPath = parentPath.concat(node.name);
      target.push({
        node: node,
        name: node.name,
        pathLabel: nextPath.join(' / ')
      });
      if (Array.isArray(node.children) && node.children.length > 0) {
        ctrl.buildFlatClassEntries(node.children, nextPath, target);
      }
    });
  };

  ctrl.refreshFlatClassEntries = function () {
    var entries = [];
    ctrl.buildFlatClassEntries(ctrl.equipmentRootNode(), [], entries);
    ctrl.flatClassEntries(entries.sort(function (a, b) {
      if (a.name === b.name) {
        return a.pathLabel.localeCompare(b.pathLabel);
      }
      return a.name.localeCompare(b.name);
    }));
  };

  ctrl.getSearchResults = function () {
    var query = String(ctrl.searchTerm() || '').trim().toLowerCase();
    if (!query) return [];
    return ctrl.flatClassEntries()
      .filter(function (entry) {
        return entry.name.toLowerCase().includes(query) ||
          entry.pathLabel.toLowerCase().includes(query);
      });
  };

  ctrl.init = function () {
    ctrl.equipmentRootNode(equipmentModel.equipmentClassTree.categories.filter(c => c.name != 'Overview'));
    ctrl.refreshFlatClassEntries();
    ctrl.selectRoot();
  };
  ctrl.init();

};

component.onbeforeupdate = function (vnode) {
  this.selectedEquipmentClass = vnode.attrs.equipmentClass;
  this.onClassChange = vnode.attrs.onClassChange;
  return true;
};

component.view = function (vnode) {
  var ctrl = this;
  var query = String(ctrl.searchTerm() || '').trim();
  var searchResults = ctrl.getSearchResults();
  return m('div.pb2', [
    m('div.pb2.bb.bw1.b--mid-gray.near-white.mt2',  [
      function () {
        if(!ctrl.selectedNode()) return 
        else if(ctrl.rootNodeSelected()){
          return m('div.dib-ns.mr2.active.f3', [
            'Main Classes',
            m('span.near-white', ' / ')
          ])
        }else{
          return ctrl.path().map(function (node, idx){
            if(node == 'root'){
              return m('div.dib-ns.mr2.blue.f3', {
                onclick: () => ctrl.selectRoot()
              }, [
                'Main Classes',
                m('span.near-white', ' / ')
              ])
            }
            else{
              return m('div.dib-ns.mr2', {
                class: (idx+1) === ctrl.path().length ? "active" : "blue", 
                onclick: function(){
                  ctrl.path().splice(idx, ctrl.path().length)
                  selectNode(ctrl, node)
                }, 
                //config: m.route
              }, [
                node.name,
                m('span.near-white', ' / ')
              ])
            }
          })
        }
      }()
    ]),
    m('div.mt2.mb2', [
      m('input.form-control.w-100', {
        type: 'text',
        placeholder: 'Search equipment class',
        value: ctrl.searchTerm(),
        oninput: function (event) {
          ctrl.searchTerm(event && event.target ? event.target.value : '');
        }
      })
    ]),
    query
      ? m('div', [
        searchResults.length === 0
          ? m('div.f6.gray.mt2', 'No matching classes found.')
          : searchResults.map(function (entry, idx) {
            return m(verticalListItem, {
              key: entry.pathLabel + '::' + idx,
              label: m('div', [
                m('div.dark-blue', entry.name),
                m('div.f7.gray.mt1', entry.pathLabel)
              ]),
              labelClass: 'dark-blue',
              onclickLabel: function () {
                selectEquipment(ctrl, entry.node);
              }
            }, [
              m('i', {
                onclick: function () { selectEquipment(ctrl, entry.node); },
                class: 'fr f3 b ' +
                  (ctrl.selectedEquipmentClass() === entry.name ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')
              })
            ]);
          })
      ])
      : m('div', [
        ctrl.rootNodeSelected() ?
          Object.keys(ctrl.selectedNode()).map(nodeKey => {
            return nodeItem(ctrl, ctrl.selectedNode()[nodeKey], nodeKey)
          })
        :
          ctrl.selectedNode().children.sort((a, b) => a.name.localeCompare(b.name)).map(nodeKey => {
            return nodeItem(ctrl, nodeKey, nodeKey.name)
          })
      ])
  ]);
};

function nodeItem(ctrl, item, nodeKey){
  return m(verticalListItem, {
    label: m('span', [
      item.name,
      Array.isArray(item.children) && item.children.length > 0 ?
        m('i', {
          class: 'dark-blue ion-ios-arrow-right ml2 f3 b'
        })
      : ''
    ]),
    labelClass: 'dark-blue',
    onclickLabel: () => {
      Array.isArray(item.children) && item.children.length > 0 ?
        selectNode(ctrl, item)
      :
        selectEquipment(ctrl, item)
    }
  }, [
    m('i', {
      onclick: () => { selectEquipment(ctrl, item) },
      class: 'fr f3 b ' +
        (ctrl.selectedEquipmentClass() === item.name ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')
    })
  ])
}

function selectNode (ctrl, node) {
  ctrl.rootNodeSelected(false);
  ctrl.selectedEquipmentClass(null);
  ctrl.selectedNode(node);
  ctrl.path().push(node);
}

function selectEquipment(ctrl, equipment) {
  ctrl.selectedEquipmentClass(equipment.name);
  if (typeof ctrl.onClassChange === 'function') {
    ctrl.onClassChange(equipment.name, equipment);
  }
}

module.exports = component;
